import { createAction, props } from '@ngrx/store';

export enum MessengerActions {
  Disabled = '[Messenger] Disabled',
}

export const setDisabled = createAction(
  MessengerActions.Disabled,
  props<{
    disabled: boolean;
  }>(),
);
